module.exports = __webpack_public_path__ + "img/jan-1.369b99fb.jpg";